export const FirebaseConfig = {
  apiKey: "AIzaSyBtfVDyrvgrjdo-B2TxTx1uF8MegvEqH8I",
  authDomain: "applica-taxi.firebaseapp.com",
  databaseURL: "https://applica-taxi.firebaseio.com",
  projectId: "applica-taxi",
  storageBucket: "applica-taxi.appspot.com",
  messagingSenderId: "672896142743",
  appId: "1:672896142743:web:76327f872f330929e108d2",
  measurementId: "G-6P44NDKX86"
};

export const google_map_key = 'AIzaSyAo8-RdzNZdaGDIk9DkCkAwLIMYEh9Jj0Y';